module.exports = __webpack_public_path__ + "static/img/icon-contract.8924f1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-contract.png
// module id = ukEb
// module chunks = 21